import React from 'react';
import _ from 'lodash';

import {
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

export default class TextBoxField extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      errors: false,
      touched_and_blank: false,
      value: this.props.field_value,
      class_names: '',
      value: ''
    }
  }

  componentDidMount = () => {
      //console.log('CharField componentDidMount');
      if (this.props.editingInstance[this.props.field_id]) {
          this.setState({value: this.props.editingInstance[this.props.field_id]});
      }
      if (this.props.focus === this.props.field_id) {
          $(`#${this.props.field_id}`).focus();
      }
  }

  onChange = (e) => {
    let value = e.target.value;
    //let value = e.target.value
    //this.props.onSelectChange(key, value);
    this.setState({value});
    // console.log('value');
    // console.log(value);
    // console.log('String(value).length > 0 && String(value) !== null');
    // console.log(String(value).length > 0 && String(value) !== 'null');
    if (String(value).length > 0 && String(value) !== 'null') {
      this.setState({
        errors: false,
        touched_and_blank: false,
        class_names: '',
      });
      //this.props.onHandleSuccess(key);
    }
    if (!value && this.props.field_required === true) {
      this.setState({
        errors: true,
        touched_and_blank: false,
        class_names: 'error',
      });
      //this.props.onHandleErrors(key);
    }
    this.props.onSelectChange(this.props.field_id, value);
  }

  // handleBlur = () => {
  //   /*
  //   if (this.props.field_required === true && !this.state.value) {
  //     this.props.onHandleErrors(this.props.data_key);
  //     this.setState({touched_and_blank: true, class_names: 'error'});
  //   }
  //   */
  //   this.props.onSelectChange(this.props.field_id, this.state.value);
  // }

  render() {
    return (
        <FormControl
          id={`${this.props.field_id}`}
          componentClass="textarea"
          value={this.state.value}
          name={`${this.props.field_id}`}
          ref={`${this.props.field_id}`}
          onChange={this.onChange}
          className={this.state.class_names}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/textbox_field.js